export default "__VITE_ASSET__45d67056__"